import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { City, Country, CustomerSite, StateProvince } from '../../common/model/shared.model'
import { environment } from '../../../environments/environment';
import { UserRoles } from "../model/UserRole";

@Injectable({
    providedIn: 'root'
})

export class MasterDataService {
    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;
    getProvincesUrl = environment.apiBaseUrl + "MasterData/getprovinces";
    getCountriesUrl = environment.apiBaseUrl + "MasterData/getcountries";
    getCitiesUrl = environment.apiBaseUrl + "MasterData/getcities";
    getCustomerSitesUrl = environment.apiBaseUrl + "Site/getcustomersites";
    getRolesForUserUrl = environment.apiBaseUrl + "UserRole/getrolesforuser";

    getCountries(): Observable<Country[]> {
        let url = this.getCountriesUrl;
        return this.http.get<Country[]>(url);
    }

    getProvinces(): Observable<StateProvince[]> {
        let url = this.getProvincesUrl;
        return this.http.get<StateProvince[]>(url);
    }

    getCities(province:number): Observable<City[]> {
        let url = this.getCitiesUrl;
        return this.http.get<City[]>(`${url}?provinceId=${province}`);
    }

    getCustomerSites(): Observable<CustomerSite[]> {
        let url = this.getCustomerSitesUrl;
        return this.http.get<CustomerSite[]>(url);
    }

    getUserRoles() :Observable<UserRoles[]>{
        return this.http.get<UserRoles[]>(this.getRolesForUserUrl);
    }
}